import type { TOC } from '@ember/component/template-only';
import BasicRadioGroup, {
  type Signature as BasicRadioGroupSig
} from './basic-radio-group.gts';

export interface Signature {
  Args: Pick<
    BasicRadioGroupSig['Args'],
    | 'current'
    | 'onChange'
    | 'isReadOnly'
    | 'title'
    | 'propertyName'
    | 'translationKey'
    | 'isMandatory'
  >;
  Blocks: {
    default: [BasicRadioGroupSig['Blocks']['default'][0]];
  };
  Element: HTMLDivElement;
}

const FieldsRadioGroup: TOC<Signature> = <template>
  <div class='grouped fields' ...attributes>
    <BasicRadioGroup
      @current={{@current}}
      @onChange={{@onChange}}
      @isReadOnly={{@isReadOnly}}
      @title={{@title}}
      @propertyName={{@propertyName}}
      @translationKey={{@translationKey}}
      @isMandatory={{@isMandatory}}
      as |Group|
    >
      {{yield Group}}
    </BasicRadioGroup>
  </div>
</template>;

export default FieldsRadioGroup;
